"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCertifydPurchaseUrl = exports.getVariantNameFromDimensions = void 0;
// Certificate variant mapping based on pixel dimensions
const CERTIFICATE_VARIANTS = [
    { width: 800, height: 566, name: "landscape" },
    { width: 566, height: 800, name: "portrait" },
    { width: 792, height: 612, name: "us-letter-landscape" },
    { width: 612, height: 792, name: "us-letter-portrait" },
    { width: 1280, height: 720, name: "169-landscape" },
    { width: 1009, height: 612, name: "legal-landscape" },
    { width: 612, height: 1009, name: "legal-portrait" },
];
/**
 * Gets the variant name based on certificate dimensions
 * @param width - Width in pixels
 * @param height - Height in pixels
 * @returns The variant name string or null if no match found
 */
function getVariantNameFromDimensions(width, height) {
    const variant = CERTIFICATE_VARIANTS.find((v) => v.width === width && v.height === height);
    return variant ? variant.name : null;
}
exports.getVariantNameFromDimensions = getVariantNameFromDimensions;
/**
 * Constructs the Certifyd purchase URL for a credential
 * @param credentialNo - The credential number
 * @param variantName - The certificate variant name
 * @param credentialId - The credential ID to include in the URL
 * @returns The complete purchase URL
 */
function buildCertifydPurchaseUrl(variantName, credentialId) {
    return `https://api.certifyd.co/Credential/${credentialId}?platform=Sertifier&variant=${variantName}`;
}
exports.buildCertifydPurchaseUrl = buildCertifydPurchaseUrl;
